import CacheStorage from '../cache/storage.js';


export default class ImportRecord {


	constructor(params = {}) 
	{
		this.$element  = params.$element;

		this.cached_key = params.cached_key;

		this.$status   = $(this.$element).find('.import-status');

		this.id = $(this.$element).find('input[name=id]').val();
	}


	markAsQueued()
	{
		(new CacheStorage).addToArray(this.cached_key, this.id);

		return this;
	}


	isCached()
	{
		return (new CacheStorage).isCachedInArray(this.cached_key, this.id);
	}


	render()
	{
		this.loading();

		if (this.isCached()) {

			this.queued();

		} else {

			this.unqueued();

		}

		return this;
	}


	loading() 
	{
		this.$status.html(`<div class='spinner-border' role='status'></div>`);

		return this;
	}


	unqueued() 
	{
		this.$status.html(`<span class='badge badge-warning'>unqueued</span>`);

		return this;
	}


	queued() 
	{
		this.$status.html(`<span class='badge badge-success'>queued</span>`);

		return this;
	}


}